module.exports = __webpack_public_path__ + "img/bj.8f5d1c2d.svg";